// 1.- css
import "../../public/index.css";

// 2.- worker
import { workerFunction } from "../worker.js";

// 3.- helpers
import { formatTimestamp } from "./helpers.js";

export function initStatusWidget() {
    const idWidget = crypto.randomUUID();
    let params;

    function parseQuery(query) {
        const Params = {};
        if (!query) return Params;
        const Pairs = query.split(/[;&]/);
        for (let i = 0; i < Pairs.length; i++) {
            const KeyVal = Pairs[i].split("=");
            if (!KeyVal || KeyVal.length !== 2) continue;
            const key = decodeURIComponent(KeyVal[0]);
            let val = decodeURIComponent(KeyVal[1]);
            val = val.replace(/\+/g, " ");
            Params[key] = val;
        }
        return Params;
    }

    (function () {
        const scripts = Array.from(document.getElementsByTagName("script"));
        const thisScript = scripts.find((script) => script.src.includes("cemtrik-status.js"));
        // eslint-disable-next-line no-useless-escape
        const queryString = thisScript ? thisScript.src.replace(/^[^\?]+\??/, "") : "";
        params = parseQuery(queryString);
    })();

    params.domain = window.location.href;

    if (window !== self) workerFunction();

    const worker = new Worker(
        URL.createObjectURL(
            new Blob(["(" + workerFunction.toString() + ")()"], {
                type: "text/javascript",
            }),
        ),
    );

    const createShadowRoot = () => {
        const body = document.querySelector("body");
        const shadowHost = document.createElement("div");
        shadowHost.id = "cemtrik-status-root";
        const shadowRoot = shadowHost.attachShadow({ mode: "open" });

        const styleLink = document.createElement("link");
        styleLink.setAttribute("rel", "stylesheet");
        styleLink.setAttribute(
            "href",
            process.env.NODE_ENV === "development" ? "./index.css" : process.env.URL_CSS,
        );
        shadowRoot.appendChild(styleLink);

        const main = document.createElement("main");
        main.className = "main-cemtrik-status";
        main.id = `root-cemtrik-status-root-${idWidget}`;
        main.style = "letter-spacing: 0";

        shadowRoot.appendChild(main);
        body.appendChild(shadowHost);

        return shadowRoot;
    };

    const documentShadowRoot = createShadowRoot();
    const main = documentShadowRoot.querySelector("main");

    const url = new URL(params.domain);
    const searchParams = url.searchParams;
    const domain = searchParams.get("domain");
    const isWhiteList = process.env.WHITE_LIST.includes(domain);

    const renderNoAccess = () => {
        main.innerHTML = `
            <div class="max-w-xl mx-auto p-6 bg-white text-center font-sans">
                <h2 class="text-lg font-semibold text-red-600 mb-2">
                    Acceso restringido
                </h2>
                <p class="text-gray-600">
                    No se cuenta con acceso a este recurso.
                </p>
            </div>
        `;
    };

    if (!isWhiteList) return renderNoAccess();
    main.innerHTML = `
        <div
            class="w-full h-screen overflow-hidden bg-stone-600 opacity-75 flex flex-col items-center justify-center"
        >
            <div
                class="inline-block h-12 w-12 animate-spin rounded-full bg-current opacity-0"
                role="status"
            ></div>
            <svg
                class="fill-current animate-spin w-8 h-8 text-indigo-800 animate-spin"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <circle
                    class="opacity-25 stroke-current"
                    cx="12"
                    cy="12"
                    r="10"
                    strokeWidth="4"
                    fill="none"
                ></circle>
                <path d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
        </div>
    `;

    const STATUS_COLORS = {
        OK: "bg-green-500",
        NO_DATA: "bg-green-500",
        WARN: "bg-yellow-500",
        ALERT: "bg-red-500",
    };
    const STATUS_TEXT = {
        OK: "Disponible",
        NO_DATA: "Disponible",
        WARN: "Parcialmente disponible",
        ALERT: "Disponibilidad afectada",
    };
    const SERVICE_NAMES = {
        forms: "Respuestas",
        invitations: "Invitaciones",
        superset: "Analítica y BI",
    };

    function renderTable({ services, lastTimeUpdate }) {
        let tableRows = "";
        services.forEach((service) => {
            tableRows += `
                <tr class="border-b border-gray-300">
                    <td class="p-2 pl-10 text-gray-600">
                        ${SERVICE_NAMES[service.name]}
                    </td>
                    <td class="p-2 flex items-center justify-between pr-10">
                        <span class="text-gray-600 truncate mr-3">
                            ${STATUS_TEXT[service.status]}
                        </span>
                        <span class="inline-block h-3 w-3 rounded-full ${STATUS_COLORS[service.status]} flex-shrink-0"></span>
                    </td>
                </tr>
            `;
        });
        main.innerHTML = `
            <div class="max-w-2xl mx-auto p-6 bg-white font-sans">
                <h2 class="text-xl font-semibold mb-10 text-gray-800 text-center">
                    Estado de salud del sistema
                </h2>
                <div class="flex justify-end items-center mb-3">
                    <span class="text-gray-600 ml-1 text-sm">
                       Última actualización hoy, ${formatTimestamp(lastTimeUpdate)} Colombia Standard Time.
                    </span>
                </div>
                <div class="border border-gray-300 rounded-md overflow-hidden">
                    <table class="w-full border-collapse text-sm">
                        <thead class="bg-gray-50">
                            <tr class="border-b border-gray-300">
                                <th class="text-gray-600 p-2 pl-10 text-left">Servicio</th>
                                <th class="text-gray-600 p-2 pr-10 text-center" style="width: 100px;">Estado</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${tableRows}
                        </tbody>
                    </table>
                </div>
                <p class="text-sm text-gray-600 mt-5">Si estás experimentando un problema que no está descrito en la lista, <a
                        className="text-blue-500 underline cursor-pointer"
                        href="mailto:soporte@cemtrik.com"
                        style="color: #2563eb; text-decoration: underline;"
                    >
                        ponte en contacto con el equipo de soporte técnico
                    </a></p>
            </div>
        `;
    }

    worker.postMessage({});

    worker.addEventListener("message", (e) => {
        const {
            data: { data },
        } = e;
        const { data: response, status } = data;
        if (status !== 200) return;
        const { services, lastTimeUpdate } = response;
        renderTable({ services, lastTimeUpdate });
    });
}
